export const RSFT_DELIVER_TO_DELIVERY_COUNTRY_REFERRAL_NAME =
  "RSFT_DELIVER_TO_DELIVERY_COUNTRY";
export const RSFT_DELIVER_ELSEWHERE_REFERRAL_NAME = "RSFT_DELIVER_ELSEWHERE";
export const RSFT_ANALYTICS_IMPRESSION_DELAY = 2000;
